import { Modal } from 'antd';
import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { setModalState } from '../../../../../../reducers/Modal/actions';
import { MODAL_ADD_ASSET } from '../../../../../../reducers/Modal/types';
import {
  ZorbaButton,
  PlacesAutoComplete,
  ZorbaSelect,
} from '../../../../../../components/forms';
import { BUTTON_VARIANT_DARK } from '../../../../../../components/forms/ZorbaButton/constants';
import { postRequest } from '../../../../../../services/requestService';
import {
  showErrorToast,
  showSuccessToast,
} from '../../../../../../services/notificationsService';
import { fetchAssets } from '../../../../../../reducers/Assets/actions';

import './index.scss';

export const AddAssetModal = () => {
  const { isAddAssetModalOpen } = useSelector(
    ({ ModalReducer }) => ModalReducer,
  );
  const { entities } = useSelector(({ EntitiesReducer }) => EntitiesReducer);
  const dispatch = useDispatch();
  const [selectedEntity, setSelectedEntity] = useState('');
  const [selectedAddress, setSelectedAddress] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleCloseModal = () => {
    setSelectedEntity('');
    setSelectedAddress('');
    dispatch(setModalState(MODAL_ADD_ASSET, false));
  };

  const onPlacesChange = (address) => {
    if (!address?.formattedAddress) return;
    setSelectedAddress(address);
  };

  const handleCreateAsset = async () => {
    try {
      setIsLoading(true);
      await postRequest('/buyers/assets/create-asset', {
        address: selectedAddress,
        entityName: selectedEntity,
      });
      setIsLoading(false);
      dispatch(fetchAssets());
      handleCloseModal();
      showSuccessToast('Entity created successfully');
    } catch (error) {
      showErrorToast(error.response?.data?.reason || 'Importing asset failed!');
      setIsLoading(false);
    }
  };

  const entitiesOptions = entities.map((entity) => ({
    label: entity.name,
    value: entity.name,
  }));

  const filterOption = (input, option) =>
    (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

  return (
    <Modal
      open={isAddAssetModalOpen}
      footer={null}
      onCancel={handleCloseModal}
      title="Import asset to your organization"
      className="import-asset-modal"
      destroyOnClose
    >
      <div className="input-container">
        <PlacesAutoComplete
          placeholder="3723 Temple St, Tampa, FL 33619"
          clearInputOnSelect={false}
          clearInputOnBlur={false}
          onChange={(address) => onPlacesChange(address)}
          allowFullAddress
          showOnlyFullAddresses
        />
      </div>
      <div>
        <ZorbaSelect
          label="Owning entity"
          options={entitiesOptions}
          value={selectedEntity}
          onChange={(val) => setSelectedEntity(val)}
          filterOption={filterOption}
          showSearch
        />
      </div>
      <div className="create-button-container">
        <ZorbaButton
          fullWidth={false}
          variant={BUTTON_VARIANT_DARK}
          onClick={handleCreateAsset}
          disabled={isLoading || !selectedAddress || !selectedEntity}
          loading={isLoading}
        >
          Import
        </ZorbaButton>
      </div>
    </Modal>
  );
};
